module.exports = __webpack_public_path__ + "img/email-fail.ac987b87.svg";